// extracted by mini-css-extract-plugin
export default {"main_css_us":"Button_main_css_us__nmaFl","main_css_jp":"Button_main_css_jp__u0E8X"};